
import React, { useLayoutEffect, useRef } from 'react'
import { useGLTF, useScroll } from '@react-three/drei'
import gsap from 'gsap/gsap-core'
import { useFrame } from '@react-three/fiber'

export function Iphone(props) {
  const { nodes, materials } = useGLTF('./models/iphone/iphone_14_pro-transformed.glb')
  const iphone = useRef()
  const scroll = useScroll()
  const tl = useRef()

  useFrame((state, delta)=>{
    tl.current.seek(scroll.offset * tl.current.duration())
  })

  useLayoutEffect(()=>{
    tl.current = gsap.timeline({defaults: {duration: 5, ease: 'power1.inOut'}})
    tl.current
    .to(iphone.current.rotation, { y: Math.PI * 0.8})
    .to(iphone.current.position, {x: 1}, 2)

    .to(iphone.current.rotation, { y: Math.PI}, 6) 
    .to(iphone.current.position, {x: -2}, 6)

    .to(iphone.current.rotation, {x: Math.PI * 0.5}, 11)
    .to(iphone.current.position, {x: -1}, 11)

    .to(iphone.current.rotation, { y: Math.PI }, 13)
    .to(iphone.current.position, {x: 0}, 13)

    .to(iphone.current.rotation, { y: Math.PI }, 16)
    .to(iphone.current.rotation, {x: Math.PI * 0.7}, 16) 
    .to(iphone.current.position, {x: 0}, 16)    

    .to(iphone.current.rotation, { y: Math.PI * 0.9 }, 20)
    .to(iphone.current.rotation, {x: Math.PI * 2}, 20) 
    .to(iphone.current.position, {y: 0.4}, 20)
    .to(iphone.current.position, {x: 0}, 20)   
  }, [])
  return (
    <group {...props} dispose={null} ref={iphone}>
    <mesh geometry={nodes.defaultMaterial.geometry} material={materials.Material} scale={0.2} />
  </group>
  )
}

useGLTF.preload('./models/iphone/iphone_14_pro-transformed.glb')
